module.exports = __webpack_public_path__ + "img/button-metamask-disabled.2e37f9e6.svg";